import { connect } from 'react-redux';
import NexMonitorScreen from '../components/NexMonitorScreen/';
import actions from '../../actions';

const mapStateToProps = (state) => ({
    transactions: state.transaction.nexMonitorFilteredResults,
    total: state.transaction.nexMonitorCount,
    totalPages: state.transaction.nexMonitorTotalPages,
    currentPage: state.transaction.nexMonitorCurrent,

    allTransactions: state.transaction.nexMonitorResults,

    loading: state.transaction.getNexMonitorTransactionsStatus.loading,
    downloadStatus: state.transaction.downloadNexMonitorTransactionsStatus,

    sendDataToSAPStatus: state.transaction.sendDataToSAPStatus,
    sendDataToSAPResults: state.transaction.lastSendDataToSAPResults,

    userIsPayer: state.profile.user.groups?.includes('pagadores'),
    userType: state.profile.user.type,
});

const mapDispatchToProps = (dispatch) => ({
    getTransactions: (filter, page, search, startDate, endDate, order) =>
        dispatch(
            actions.transaction.getNexMonitorTransactionsByFilters(
                filter,
                page,
                search,
                startDate,
                endDate,
                order,
            ),
        ),

    sendDataToSAP: (transactions) => dispatch(actions.transaction.sendDataToSAP(transactions)),

    downloadTransactions: (filter, page, search, startDate, endDate, order) =>
        dispatch(
            actions.transaction.downloadNexMonitorTransactions(
                filter,
                page,
                search,
                startDate,
                endDate,
                order,
            ),
        ),

    clearUI: () => dispatch(actions.transaction.clearUI()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NexMonitorScreen);
